import { AxiosError } from 'axios';
import { POST_ACCOUNT_MANAGEMENT_ACTION_URL } from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: void) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostAccountManagementAction = ({ onSuccess, onError }: Input) => {
  const postAccountManagementAction = async (reqBody: any) => {
    const res = await axiosClient.post<void>(
      POST_ACCOUNT_MANAGEMENT_ACTION_URL(reqBody.actionType),
      reqBody.payload
    );
    return res.data;
  };

  return useCustomMutation(postAccountManagementAction, {
    onSuccess,
    onError,
  });
};
